// Парсер URL → тип страницы

/**
 * Парсит URL путь и определяет тип страницы
 * @param {string} path - путь URL
 * @returns {object} - объект с типом страницы и параметрами
 */
export function parseRoute(path) {
  // Нормализуем путь: убираем начальный и конечный слеш
  const normalizedPath = path.replace(/^\/+|\/+$/g, '');

  // Специальные маршруты
  if (normalizedPath === '' || normalizedPath === '/') {
    return { type: 'home' };
  }

  if (normalizedPath === 'telegram') {
    return { type: 'telegram' };
  }

  if (normalizedPath === 'hr') {
    return { type: 'hr' };
  }

  if (normalizedPath === 'music') {
    return { type: 'music' };
  }

  if (normalizedPath === 'skazki') {
    return { type: 'skazki' };
  }

  if (normalizedPath.startsWith('skazki/s/')) {
    const taleId = normalizedPath.replace('skazki/s/', '').replace(/\/+$/, '');
    if (taleId) return { type: 'skazkiTale', taleId };
    return { type: 'skazki' };
  }

  if (normalizedPath === 'skazki/new') {
    return { type: 'skazkiNew' };
  }

  if (normalizedPath === 'blog') {
    return { type: 'blog' };
  }

  if (normalizedPath.startsWith('blog/')) {
    const slug = normalizedPath.replace('blog/', '').replace(/\/+$/, '');
    if (slug) {
      return { type: 'blogArticle', slug };
    }
    return { type: 'blog' };
  }

  return { type: 'notFound' };
}
